import React from 'react';

import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

import { EmailValidation } from './EmailValidation';
import { FieldRequirement } from './FieldRequirement';
import { LabelText } from './LabelText';
import { LabelVisibility } from './LabelVisibility';
import { PlaceholderText } from './PlaceholderText';

interface Props {
  nodeIds: string[];
}

export const TextInputToolbox = React.memo(({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds, (node) => ({
    props: node?.data.props || {},
  }));
  return (
    <Section name="Text Input Settings">
      <LabelText setProps={setProps} label={props.label} inputNamePrefix="text-input" />
      <PlaceholderText
        setProps={setProps}
        placeholder={props.placeholder}
        inputNamePrefix="text-input"
      />
      <LabelVisibility
        showLabel={props.showLabel}
        setProps={setProps}
        inputNamePrefix="text-input"
      />
      <FieldRequirement
        setProps={setProps}
        inputNamePrefix="text-input"
        validation={props.validation}
        label={props.label}
      />
      {props.type === 'email' && (
        <EmailValidation validation={props.validation} setProps={setProps} />
      )}
    </Section>
  );
});
